import httpClient from '@/utils/httpClient';

export interface ParsedCommand {
  action: string;
  params: Record<string, any>;
  missingFields?: string[];
  summary: string;
  confirmationType?: 'auto' | 'confirm' | 'confirm_with_warning';
}

interface ParseResponse {
  success: boolean;
  parsed: ParsedCommand;
}

export interface ExecuteResponse {
  success: boolean;
  message?: string;
  error?: string;
  data?: any;
  navigate?: string;
}

export const aiCommandService = {
  async parse(command: string): Promise<ParsedCommand> {
    const response = await httpClient.post<ParseResponse>('/ai-command/parse', { command });
    return response.parsed;
  },

  async execute(action: string, params: Record<string, any>): Promise<ExecuteResponse> {
    return httpClient.post<ExecuteResponse>('/ai-command/execute', { action, params });
  }
};
